import CircularPreview from "./editor/circularPreview";
import LinearPreview from "./editor/linearPreview";
import Overview from "./editor/overview";
import TabsEditor from "./editor/tabs";
import Mediator from "./mixins/mediator";
import LinearCartoon from "./editor/linearCartoon";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".editor").forEach((el) => {
        const linear = el.dataset.editorLinear !== undefined;
        const slotted = el.dataset.editorSlotted !== undefined;
        const editorIsEditable = el.dataset.editable !== undefined;
        const activeValidate = el.dataset.activeValidate !== undefined;
        const activeOptimization = el.dataset.activeOptimization !== undefined;

        let editorPath = linear ? "./editor/linear" : "./editor/circular";

        import(`${editorPath}`).then(Editor => {
            const mediator = new Mediator();
            const editor = new Editor.default({
                "user_id": el.dataset.userId,
                "ws_path": el.dataset.wsPath,
                "contextId": el.dataset.contextId,
                "contextType": el.dataset.contextType,
                "editable": editorIsEditable,
                "initialPosition": el.dataset.initialPosition,
                "circular": !linear,
                "annotation_colors": JSON.parse(document.getElementById("colors").innerHTML),
                "urlRestEnzymes": el.dataset.urlRestrictionEnzymes,
                "currency": el.dataset.currency,
                "editorType": el.dataset.editorType
            }, mediator)
            if (linear) {
                new LinearPreview({
                    "hasSlots": slotted,
                    "contextId": el.dataset.contextId,
                    "contextType": el.dataset.contextType,
                    "initialPosition": el.dataset.initialPosition,
                    "annotation_colors": JSON.parse(document.getElementById("colors").innerHTML)
                }, mediator);
            } else {
                new CircularPreview({
                    "hasSlots": slotted,
                    "contextId": el.dataset.contextId,
                    "contextType": el.dataset.contextType,
                    "annotation_colors": JSON.parse(document.getElementById("colors").innerHTML)
                }, mediator);
            }

            new Overview({
                "circular": !linear,
                "editable": editorIsEditable,
                "hasSlots": slotted,
                "initialPosition": el.dataset.initialPosition,
                "activeValidate": activeValidate,
                "activeOptimization": activeOptimization
            }, mediator);
            new TabsEditor({
                "circular": !linear,
                "hasSlots": slotted,
                "annotation_colors": JSON.parse(document.getElementById("colors").innerHTML),
                "contextId": el.dataset.contextId,
                "contextType": el.dataset.contextType,
                "currency": el.dataset.currency,
                "editorType": el.dataset.editorType
            }, mediator);

            if (linear && slotted) {
                new LinearCartoon({}, mediator)
            }

            editor.initWS();
            window.editor = editor;
        });
    })
});
